import React from 'react';
import { motion } from 'framer-motion';
import './AboutUsHero.css';

const AboutUsHero: React.FC = () => {
  return (
    <motion.section
      className="about-hero-enhanced"
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1, ease: 'easeOut' }}
    >
      <div className="about-hero-background-image">
        <img
          src="/medical-banner-with-doctor-wearing-goggles-scaled.webp"
          alt="Advanced medical technology and research"
          className="about-hero-bg-img"
        />
        <div className="about-hero-overlay"></div>
      </div>

      <div className="about-hero-content-overlay">
        <div className="about-hero-content-inner">
          <div className="about-hero-badge">
            <span className="badge-text">Pioneering eCOA Excellence</span>
          </div>

          <h1 className="about-hero-title">
            Empowering Clinical Research Through{' '}
            <span className="highlight">AI Innovation</span>
          </h1>

          <p className="about-hero-subtitle">
            At Cinquity, we're revolutionizing clinical trials with AI-powered eCOA solutions that deliver unprecedented efficiency, accuracy, and patient engagement. Our cutting-edge platform transforms how pharmaceutical companies and research institutions collect, validate, and analyze clinical data.
          </p>

          <div className="about-hero-stats">
            <div className="stat-item">
              <span className="stat-number">500+</span>
              <span className="stat-label">Clinical Trials</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">99.9%</span>
              <span className="stat-label">Data Accuracy</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">24/7</span>
              <span className="stat-label">Support</span>
            </div>
          </div>
        </div>
      </div>
    </motion.section>
  );
};

export default AboutUsHero;
